// extracted by mini-css-extract-plugin
export default {"toggle-container":"Toggle_toggle-container__BfSPz","toggle-button":"Toggle_toggle-button__EtaCf","active":"Toggle_active__iqMIb"};